module.exports = __webpack_public_path__ + "img/gallery_hover.03d74a31.svg";